module.exports = __webpack_public_path__ + "img/flicker_gray2.2107e1b5.gif";